var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgressCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#AAAAAA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.625C10.4785 3.625 12.5 5.64648 12.5 8.125C12.5 10.6211 10.4785 12.625 8 12.625C5.50391 12.625 3.5 10.6211 3.5 8.125C3.5 6.87695 4.00977 5.73438 4.83594 4.92578C5.06445 4.69727 5.41602 4.69727 5.64453 4.92578C5.85547 5.1543 5.85547 5.50586 5.62695 5.7168C5.01172 6.33203 4.625 7.19336 4.625 8.125C4.625 9.98828 6.13672 11.5 8 11.5C9.86328 11.5 11.375 9.98828 11.375 8.125C11.375 6.45508 10.1445 5.06641 8.5625 4.80273V5.3125C8.5625 5.62891 8.29883 5.875 8 5.875C7.68359 5.875 7.4375 5.62891 7.4375 5.3125V4.1875C7.4375 3.88867 7.68359 3.625 8 3.625ZM6.89258 6.41992L8.29883 7.82617C8.45703 8.00195 8.45703 8.26562 8.29883 8.42383C8.12305 8.59961 7.85938 8.59961 7.70117 8.42383L6.29492 7.01758C6.11914 6.85938 6.11914 6.5957 6.29492 6.41992C6.45312 6.26172 6.7168 6.26172 6.89258 6.41992Z",
    fill: "#E6F2F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressCircle);
export default __webpack_public_path__ + "static/media/progress-circle.6fe8e7dfeca95f952e17762b46add3dd.svg";
export { ForwardRef as ReactComponent };